import React from "react";
import "./simpleInfoElement.scss";
import {InputLabel} from "@mui/material";

interface SimpleInfoElementProps {
    label: string;
    value?: string | null | number;
    unit?: string | "";
    testId?: string;
    className?: string;
    classNameContent?: string;
    type?: "box";
}

function SimpleInfoElement(props: SimpleInfoElementProps) {
    const fieldValue = (typeof props.value === "number") ? props.value.toString() : props.value;
    const valueChildren = (fieldValue && props.unit) ? `${fieldValue} ${props.unit}` : fieldValue;
    const value = <p className={`value ${props.classNameContent}`} data-testid={`${props.testId}-value`}>{valueChildren || "-"}</p>;
    const valueBox = <div className={`value-box ${props.classNameContent}`} data-testid={`${props.testId}-value`}>{props.value || "-"}</div>;
    const content = props.type === "box" ? valueBox : value;

    return (
        <div className={`simple-info-element ${props.className || ""}`} data-testid={props.testId}>
            <InputLabel className="label" data-testid={`${props.testId}-label`}>{props.label}</InputLabel>
            {content}
        </div>
    );
}

export default SimpleInfoElement;
